export default "__VITE_ASSET__CPwhiETy__"